module.exports = __webpack_public_path__ + "img/bow length.626984eb.png";